import { createSlice } from "@reduxjs/toolkit";
import { IntergralWorksReducer } from "../extraReducers/IntergralWorksReducer";


// 定义初始化数据
const initialState = {
    getIntegralWorksConfig: {} as any,
    updateIntegralWorksListConfig: {} as any
};

const IntergralWorksSlice = createSlice({
    name: "bonusPointsSettings",
    initialState,
    reducers: {},
    extraReducers: IntergralWorksReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default IntergralWorksSlice.reducer;
